<template>
  <h1 class="system_content_title">评价审核记录</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
     
  <el-collapse v-if="state.tableData.length" v-model="state.activeNames">
      <el-collapse-item
        v-for="(item, index) in state.tableData"
        :key="index"
        :title="item.step.flowStepname"
        :name="index"
      >
        <template #title>
          <h3 style="color: #cc783a; font-weight: bold">{{
            item.step.flowStepname
          }}</h3>
        </template>
        <p>
          本次评价得分：<span style="color: red">{{ item.step.score2 }}</span>
        </p>
        <p>本次评价等级：{{ item.step.scorelevel2 }}</p>
        <el-table :data="item.items" style="width: 100%">
          <el-table-column prop="itemTitle" label="评价项目"> </el-table-column>
          <el-table-column prop="score" label="审核分数"> </el-table-column>
          <el-table-column prop="auditsItemNames" label="指标明细">
          </el-table-column>
          <el-table-column prop="fileUrl" label="审核资料">
            <template #default="scope">
           <a v-if="scope.row.fileUrl" :href="BASE_URL+scope.row.fileUrl" target="_blank">{{getFileName(scope.row.fileUrl)}}</a>
           <span v-else　color='gray'>无</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <h1 v-else>您当前没有评价记录以供查看</h1>
     
    </div>
  
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage,ElNotification } from "element-plus";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { DArrowLeft } from "@element-plus/icons-vue";
import CONSTS from "../../store/consts";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const BASE_URL = CONSTS.BASE_URL.slice(0, -1);
    if (!route.query.taskID) {
      ElMessage({
        message: "没有该工作任务，将返回到列表",
        type: "error",
      });

      setTimeout(() => {
        router.push("/system/review/reviewTasksListCompanyAlt ");
      }, 3000);
    }
   
    const state = reactive({
      tableData: [],
      loading: false,
      searchInput: "",
      pageInfo: {},
      activeNames: ["0"],
    
      taskID: parseInt(route.query.taskID),
    });

    const getTableData = async () => {
      state.loading = true;
      const { data } = await api.auditionApi.getAudHistory(state.taskID);
      if (data.isSuccessful) {
        state.loading = false;
        state.tableData = data.resultObj
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };
    getTableData();

 
    const getFileName = (val) => {
      if (val != null) {
        if (val || val != "") {
          console.info("fileurl", val);
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    };

  
   
    

  

    return {
      state,
      getTableData,
     
      getFileName,
    
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.state.pageInfo.pageIndex = val;
      this.getTableData();
    },
    getBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
